import {
  QuestionCircle,
  FileText,
  ShieldLock,
  LifePreserver,
  ClipboardCheck,
  PersonCheck,
} from "react-bootstrap-icons";

import styles from "./Footer.module.css";
import { useSelector } from "react-redux";

const Footer = ({ applyStyling = false, showTicketBtn = true }) => {
  const sidebarVisibility = useSelector((state) => state.RS_Sidebar.show);
  const sidebarWidth = useSelector((state) => state.RS_Sidebar.sidebarWidth);
  return (
    <footer
      className={styles.footer}
      style={
        applyStyling
          ? {
              marginLeft: sidebarVisibility
                ? "calc(" + sidebarWidth + ")"
                : "0px",
            }
          : null
      }
    >
      <div className={styles.footerContent}>
        {/* ACTION BUTTONS */}
        <div className={styles.footerActions}>
          {showTicketBtn && (
            <a
              href={"https://helpdesk.loanlinq.com"}
              target="_blank"
              rel="noopener noreferrer"
              className={`${styles.footerBtn} ${styles.outline}`}
              title="Go to Helpdesk Portal"
            >
              <ClipboardCheck size={16} />
              Create a Ticket
            </a>
          )}

          <a
            href={"/vom-gateway"}
            target="_blank"
            rel="noopener noreferrer"
            className={`${styles.footerBtn} ${styles.primary}`}
            title="Request Verification of Mortgage"
          >
            <FileText size={16} />
            Request Verification of Mortgage
          </a>

          <a
            href={"/payoff-gateway"}
            target="_blank"
            rel="noopener noreferrer"
            className={`${styles.footerBtn} ${styles.outline}`}
            title="Create Payoff Request"
          >
            <FileText size={16} />
            Create Payoff Request
          </a>
        </div>

        {/* LINK GROUPS */}
        <div className={styles.footerLinks}>
          <div className={styles.footerGroup}>
            <h4 className="text-start">Support</h4>
            {/* <a href="/help" target="_blank" rel="noreferrer">
              <LifePreserver size={14} /> Help Center
            </a> */}
            <a href="https://superiorloanservicing.com/faq/" target="_blank" rel="noreferrer">
              <QuestionCircle size={14} /> FAQ
            </a>
            <a href="https://superiorloanservicing.com/contact-us/" target="_blank" rel="noreferrer">
              <QuestionCircle size={14} /> Contact Us
            </a>
          </div>

          <div className={styles.footerGroup}>
            <h4 className="text-start">Legal</h4>
            <a
              href="https://superiorloanservicing.com/privacy-policy"
              target="_blank"
              rel="noreferrer"
            >
              <ShieldLock size={14} /> Privacy Policy
            </a>
            <a
              href="https://superiorloanservicing.com/terms-of-service"
              target="_blank"
              rel="noreferrer"
            >
              <FileText size={14} /> Terms
            </a>
            {/* <a href="/accessibility" target="_blank" rel="noreferrer">
              <PersonCheck size={14} /> Accessibility
            </a> */}
          </div>
        </div>

        {/* COPYRIGHT */}
        <div className={styles.footerCopy}>
          © {new Date().getFullYear()} LoanlinQ
        </div>
      </div>
    </footer>
  );
};

export default Footer;
